import './index.less'
import React from 'react';
import { Popover } from 'antd';

class NewCourse extends React.Component{

  pop = (data) => {
    const avatarStyle = {
      width: '40px',
      height: '40px',
      borderRadius: '50%'
    }
    return (
      <div>
        {
          data.get('schedules') && data.get('teacher_name') ? <div style={{margin: '0 auto',
          height: '50px',
          width: '100%',
          borderBottom: '1px solid #E9E9E9',
          display: 'flex',
          padding: '0'}}>
            {
              data.get('avatar') ? <img style={avatarStyle} src={data.get('avatar')} alt=''/> : <img style={avatarStyle} src='https://static.cleanlive.cn/user-center/images/user.png' alt=''/>
            }
            <p style={{lineHeight: '40px',marginLeft: '10px'}}>{data.get('teacher_name')}</p>
          </div> : null
        }
        <p style={{padding: '10px 15px 0'}}>剩余可预约课时：{data.get('reservable') ? data.get('reservable') : 0}</p>
      </div>
    )
  }

  courseRender = () => {
    const dom = [];
    const { lessonsList } = this.props;
    lessonsList.map((item, i) => {
      dom.push(
        <Popover key={i} placement='bottom' content={this.pop(item)}>
          <div className='course-card'>
            <div className='course-img'>
              {
                item.get('level') && Math.log2(item.get('level')) ? <div className='course-level'>Level {Math.log2(item.get('level'))}</div> : null
              }
              {
                item.get('cover') ? <img src={item.get('cover')} alt=''/> : <img src='https://static.cleanlive.cn/user-center/images/courselist.png' alt=''/>
              }
            </div>
            <div className='course-info1'>
              <p>{item.get('name')}</p>
              {
                item.get('reservable') ? <div className='course-btn' onClick={() => this.choose(item)}>去选课</div> : null
              }
            </div>
          </div>
        </Popover>
      )
      return i
    })
    return dom;
  }

  choose = (data) => {
    const { courseSelect } = this.props;
    courseSelect(data);
  }

  render() {
    return(
      <div className="new-course">
        {
          this.courseRender()
        }
      </div>
    )
  }
}

export default NewCourse


// WEBPACK FOOTER //
// ./src/components/newCourse/newCourse.jsx